import { render, staticRenderFns } from "./SideMenuNew.vue?vue&type=template&id=edc51f72&scoped=true&"
import script from "./SideMenuNew.vue?vue&type=script&lang=js&"
export * from "./SideMenuNew.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SideMenuNew.vue?vue&type=style&index=1&lang=css&"
import style2 from "./SideMenuNew.vue?vue&type=style&index=2&id=edc51f72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc51f72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
